import ListCustomFetcher from "../list-fetcher-custom";
import ListFetcherLazy from "../list-fetcher-lazy";
import { useListContext } from "../list.context";

import ListFetcherClassic from "./list-fetcher.component";

const ListFetcherWrapper = () => {
  const { model, customEndpoint, lazy } = useListContext();

  // Make sure to render fetchers when List Context values are ready
  if (!model) return null;

  if (customEndpoint)
    return <ListCustomFetcher customEndpoint={customEndpoint} />;

  if (lazy) return <ListFetcherLazy />;

  return <ListFetcherClassic />;
};

export default ListFetcherWrapper;
